import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WindowNames } from "../../../resources/constants";

import { fetchAuth, fetchReg, fetchApplyCode } from "./asyncActions";

import { IAuthAndReg, IRespData } from "./types";

const initialState: IAuthAndReg = {
  auth: false,
  isLoading: false,
  showWindow: "",
  errorMessage: "",
};

const authAndRegSlice = createSlice({
  name: "authAndReg",
  initialState,
  reducers: {
    setAuth(state, action: PayloadAction<string | null>) {
      state.auth = action.payload ? true : false;
    },
    setShowWindow(state, action: PayloadAction<string>) {
      state.showWindow = action.payload;
      if (action.payload === WindowNames.AUTH) {
        state.errorMessage = "";
      }
    },
    resetShowWindow(state) {
      state.showWindow = "";
    },
    clearErrorMessage(state) {
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    // auth
    builder.addCase(fetchAuth.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(fetchAuth.fulfilled, (state, action: PayloadAction<IRespData>) => {
      state.isLoading = false;
      state.auth = action.payload.auth;
      state.errorMessage = "";
      if (action.payload.auth) {
        state.showWindow = action.payload.showWindow || WindowNames.AUTH_SUCCESS;
      } else if (action.payload.showWindow) {
        state.showWindow = action.payload.showWindow;
      }
    });
    builder.addCase(fetchAuth.rejected, (state, action) => {
      state.isLoading = false;
      state.auth = false;
      const errorMsg = action.error?.message || "Ошибка авторизации";
      const cleanErrorMsg = errorMsg.replace(/^\d+:/, "");
      state.errorMessage = cleanErrorMsg;
    });
    // reg
    builder.addCase(fetchReg.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(fetchReg.fulfilled, (state, action: PayloadAction<IRespData>) => {
      state.isLoading = false;
      state.auth = action.payload.auth;
      state.errorMessage = "";
      if (action.payload.showWindow) state.showWindow = action.payload.showWindow;
    });
    builder.addCase(fetchReg.rejected, (state, action) => {
      state.isLoading = false;
      state.showWindow = WindowNames.ERROR;
      state.errorMessage = action.error?.message || "Ошибка регистрации";
    });
    // code apply
    builder.addCase(fetchApplyCode.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchApplyCode.fulfilled,
      (state, action: PayloadAction<IRespData>) => {
        state.isLoading = false;
        state.auth = action.payload.auth;
        if (action.payload.showWindow) state.showWindow = action.payload.showWindow;
      }
    );
    builder.addCase(fetchApplyCode.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { setAuth, setShowWindow, resetShowWindow, clearErrorMessage } = authAndRegSlice.actions;

export default authAndRegSlice.reducer;
